export default __webpack_public_path__ + "static/media/009-bear.5c363d6f.svg";